<template>
  <div :class="['loading', { 'loading--visible': isLoaderVisible }]">
    <LoadingIcon :class="['icon', `icon--size-${iconSize}`]" />
    <div v-if="slotExists" class="loading__text">
      <slot />
    </div>
  </div>
</template>

<script>
import LoadingIcon from '@/components/icon_components/LoadingIcon.vue'
export default {
  components: {
    LoadingIcon,
  },
  props: {
    delay: {
      type: Number,
      required: false,
      default: 200,
    },
    /* Sizes: tiny, small, medium and large */
    iconSize: {
      type: String,
      required: false,
      default: 'medium',
    },
  },
  data() {
    return {
      isLoaderVisible: false,
    }
  },
  computed: {
    slotExists() {
      return this.$slots.default
    },
  },
  mounted() {
    this.showLoader()
  },
  methods: {
    showLoader() {
      setTimeout(() => {
        this.isLoaderVisible = true
      }, this.delay)
    },
  },
}
</script>

<style lang="scss" scoped>
.loading {
  display: none;
  flex-direction: column;
  align-items: center;

  &--visible {
    display: flex;
  }

  &__text {
    @include subtitle;
  }
}

.icon {
  display: flex;
  align-items: center;

  &--size-tiny {
    width: $spacing-xs;
    height: $spacing-xs;
  }
  &--size-small {
    width: $spacing-s;
    height: $spacing-s;
  }
  &--size-medium {
    width: $spacing-m;
    height: $spacing-m;
  }
  &--size-large {
    width: $spacing-l;
    height: $spacing-l;
  }
}
</style>
